export function concreteIdentityKey(productPublicId, variantPublicId = null) {
  return `${productPublicId || ""}::${variantPublicId || "simple"}`;
}

export function variantDisplayName(productName, variantLabel) {
  return variantLabel ? `${productName} · ${variantLabel}` : productName;
}

export function cartesianVariantCombinations(options = []) {
  if (!options.length || options.some((option) => !option.values?.length)) return [];

  return options.reduce(
    (combinations, option) => combinations.flatMap((combination) =>
      option.values.map((value) => ({
        values: [...combination.values, value],
        labelParts: [...combination.labelParts, `${option.name}: ${value.value}`],
      }))),
    [{ values: [], labelParts: [] }],
  ).map((combination) => ({
    optionValuePublicIds: combination.values.map((value) => value.public_id),
    signature: combination.values.map((value) => value.public_id).sort().join("|"),
    label: combination.labelParts.join(" · "),
  }));
}

export function variantSignature(optionValuePublicIds = []) {
  return [...optionValuePublicIds].sort().join("|");
}
